import {
    createSelector
} from "reselect";


export const companySelector = createSelector(state => state && state.settings && state.settings.companies, companySelector => companySelector);
